import styled from "styled-components"
import { ArticleWrapperStyles } from "./article-styles"

export const ArticleWrapper = styled.div`
  ${ArticleWrapperStyles}
`
